import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/login'
import index from '@/view/yeMast/yeMast.vue'
import video from '@/view/video/video.vue'
import noData from '@/view/noData/index.vue'
Vue.use(Router)
export default new Router({
    routes: [{
            path: '/',
            name: 'index',
            component: index
        },
        {
            path: '/video',
            name: 'video',
            component: video
        },
        {
            path: '/noData',
            name: 'noData',
            component: noData
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js